import type { CSSProperties } from 'react';

/**
 * Design system for the odds-breakdown surface — the per-rarity panel shown
 * in the odds modal.
 *
 * This is INTENTIONALLY separate from `StatsRow` (which themes the Max Pull
 * block itself, incl. its in-modal recap): operators style the breakdown
 * card, bars and "Mod:" caption independently via `--co-OddsBreakdown-*`.
 * Registered in `packages/theme-constructor/src/schema/components.ts`. Hex /
 * rgba literals are `var(..., fallback)` defaults only. See
 * [[feedback_iframe_theme_vars]].
 */

/** Card surface of the odds modal (border via knob, not a class). */
export const BREAKDOWN_CARD_STYLE: CSSProperties = {
  fontFamily: 'var(--co-OddsBreakdown-fontFamily), Inter, system-ui, sans-serif',
  backgroundImage:
    'linear-gradient(180deg, var(--co-OddsBreakdown-bgFrom, rgba(255,255,255,0.2)) 0%, var(--co-OddsBreakdown-bgTo, rgba(153,153,153,0.2)) 100%), linear-gradient(90deg, rgba(0,0,0,0.18), rgba(0,0,0,0.18))',
  borderStyle: 'solid',
  borderWidth: 'var(--co-OddsBreakdown-borderWidth, 2px)',
  borderColor: 'var(--co-OddsBreakdown-borderColor, rgba(171,174,179,0.24))',
  borderRadius: 'var(--co-OddsBreakdown-borderRadius, 28px)',
};

/** Bar track wash (sits under the rarity-coloured fill). */
export const BAR_TRACK = 'var(--co-OddsBreakdown-barTrack, rgba(255,255,255,0.05))';
/** Rarity name (left, bold). */
export const BAR_NAME_COLOR = 'var(--co-OddsBreakdown-barNameColor, #ffffff)';
/** Value range under the name. */
export const BAR_RANGE_COLOR = 'var(--co-OddsBreakdown-barRangeColor, rgba(255,255,255,0.5))';
/** Percentage (right). */
export const BAR_PERCENT_COLOR = 'var(--co-OddsBreakdown-barPercentColor, #ffffff)';
/** Bar track corner radius — pill by default. */
export const BAR_RADIUS = 'var(--co-OddsBreakdown-barRadius, 999px)';
/** Rarity fill corner radius — near-square per Figma 1578:1471. */
export const BAR_FILL_RADIUS = 'var(--co-OddsBreakdown-barFillRadius, 6px)';

/** "Mod:" caption — prefix vs value. */
export const MOD_LABEL_COLOR = 'var(--co-OddsBreakdown-modLabelColor, rgba(255,255,255,0.5))';
export const MOD_VALUE_COLOR = 'var(--co-OddsBreakdown-modValueColor, #ffffff)';
